export class GetTaxListBO {
    role: string;
    user: string | null;
    searchColumn: string;
    searchText: string;
    userId: string | null;
    currentpageno: number = 1;
    orderType: string = "asc";
    pageitem: number = 10;
    orderColumn: string = "relationship_Name";
    type: string = "string";
    field: string = "relationship_Name";
    value: string = "";
    listId: string | null;
    operator: string = "startswith";
    matchCase: boolean = false;
}
export class saveRelationshipListBO {
    id: string = "00000000-0000-0000-0000-000000000000";
    relationship_Name: string;
    lastUpdateDate: string;
}

export class saveTaxBO {
    id: string = "00000000-0000-0000-0000-000000000000";
    name: string;
    description: string;
}

export class saveTaxPercentageBO {
    id: string = "00000000-0000-0000-0000-000000000000";
    effectiveDate: string;
    percent: number;
    taxId: string;
    taxName: string;
    taxDescription: string;
    agencyId: string;
}

export class functionpermission {
    taxcreate: boolean = true
    taxupdate: boolean = true
    taxdelete: boolean = true
    taxpercentcreate: boolean = true
    taxpercentupdate: boolean = true
    taxpercentdelete: boolean = true
    relationshiplistcreate: boolean = true
    relationshiplistupdate: boolean = true
    relationshiplistdelete: boolean = true
}